import _ from 'lodash'
export function removeEmptyWidgets(pages) {
  const pagesCopy = _.cloneDeep(pages)
  
  for (let i = 0; i <= pagesCopy?.length - 1; i++) {
    if (pagesCopy[i].pageType === 'customised-page') {
      pagesCopy[i].pageContent = pagesCopy[i].pageContent.filter(content => {
        return content.widgetContent[0].subWidgets.length > 0;
      });
    }
  }
  
  return pagesCopy;
}

export function removeEmptySubWidgets(pages) {
  const pagesCopy = _.cloneDeep(pages)

  const removeEmptySubWidgetsFromWidget = (widget) => {
    widget.subWidgets = widget.subWidgets.filter(subWidget => subWidget.content !== "");
  };
  
  for (let i = 0; i < pagesCopy?.length; i++) {
    if (pagesCopy[i].pageType === 'customised-page') {
      pagesCopy[i].pageContent.forEach(content => {
        content.widgetContent.forEach(removeEmptySubWidgetsFromWidget);
      });
    }
  }

  // for (let i = 0; i < pagesCopy?.length; i++) {
  //   if (pagesCopy[i].pageType === 'customised-page') {
  //     pagesCopy[i].pageContent.forEach(content => {
  //       content.widgetContent.forEach(widget => {
  //         const originalLength = widget.subWidgets.length;
          
  //         widget.subWidgets = widget.subWidgets.filter(subWidget => subWidget.content !== "");
          
  //         if (widget.subWidgets.length < originalLength) {
  //           emptySubWidgetAdded = true; // Set flag if any subwidgets were removed
  //         }
  //       });
  //     });
  //   }
  // }
  
  return pagesCopy;
}

export function getWidgetUploadedFileKeys (widget){
  const types = ["uploaded-image", "uploaded-banner", "uploaded-video", "uploaded-pdf", "uploaded-audio"];
 
  const keysArray = [];

  for (const columnId in widget.widgetContent) {
    const column = widget.widgetContent[columnId];
    for (const subWidgetId in column.subWidgets) {
      const subWidget = column.subWidgets[subWidgetId];

      if (types.includes(subWidget.contentBlockType)) {
        if (subWidget.content && Array.isArray(subWidget.content)) {
          subWidget.content.forEach((item) => {
            if (item.key) {
              keysArray.push({ Key: item.key });
            }
          });
        }
      }
    }
  }

  return keysArray;
}

export function determineOVerviewTilePropertyName(tile, type) {
  let propertyName = "";

  switch (tile) {
    case ("mutual-plan-tile"): {
      if (type==="show-tile") {
        propertyName = "planTileDisplay"
      } else if (type==="tile-display-width") {
        propertyName = "planTileFullWidth"
      }
      break;
    }
    case ("notifications-tile"): {
      if (type==="show-tile") {
        propertyName = "notificationsTileDisplay"
      } else if (type==="tile-display-width") {
        propertyName = "notificationsTileFullWidth"
      }
      break;
    }
    case ("contact-tile"): {
      if (type==="show-tile") {
        propertyName = "contactTileDisplay"
      } else if (type==="tile-display-width") {
        propertyName = "contactTileFullWidth"
      }
      break;
    }
    case ("room-members-tile"): {
      if (type==="show-tile") {
        propertyName = "membersTileDisplay"
      } else if (type==="tile-display-width") {
        propertyName = "membersTileFullWidth"
      }
      break;
    }
    case ("intro-tile"): {
      if (type==="show-tile") {
        propertyName = "introTileDisplay"
      } else if (type==="tile-display-width") {
        propertyName = "introTileFullWidth"
      }
      break;
    }
    case ("free-text-tile"): {
      if (type==="show-tile") {
        propertyName = "freeTextTileDisplay"
      } else if (type==="tile-display-width") {
        propertyName = "freeTextTileFullWidth"
      }
      break;
    }
    case ("shared-doc-tile"): {
      if (type==="show-tile") {
        propertyName = "sharedDocTileDisplay"
      } else if (type==="tile-display-width") {
        propertyName = "sharedDocTileFullWidth"
      }
      break;
    }
    case ("iframe-embed-tile"): {
      if (type==="show-tile") {
        propertyName = "iframeEmbedTileDisplay"
      } else if (type==="tile-display-width") {
        propertyName = "iframeEmbedTileFullWidth"
      }
      break;
    }
    default: {
      break;
    }
  }

  return propertyName

}